import React, { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { useUserDataContext } from "../../../user_data_context";
import { useNavigate } from "react-router-dom";
import MainBlockButtons from "./admin_groups_tab_buttons";
import AdminPageGroupsTab from "./admin_page_groups_tab";
import AdminPageVotesTab from "./admin_page_votes_tab";

const AdminPageGroupsContainer = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
`;

const AdminPageGroups = () => {
  const navigate = useNavigate();

  const { userData, accessRights } = useUserDataContext();

  const [activeTab, setActiveTab] = useState("groups"); // groups, votes

  const hasAccess =
    accessRights.isSuperadmin ||
    accessRights.isAdminOfPlatformGroups ||
    accessRights.isAdminOfGroups ||
    accessRights.isAuthor;

  if (!hasAccess) return;

  useEffect(() => {
    if (userData._id && !hasAccess) {
      navigate("/bible");
    }

    if (userData._id && hasAccess) {
      localStorage.setItem("lastAdminUrl", location.pathname);
    }
  }, [accessRights, userData]);

  return (
    <AdminPageGroupsContainer>
      <MainBlockButtons activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === "groups" && <AdminPageGroupsTab />}
      {activeTab === "votes" && <AdminPageVotesTab />}
    </AdminPageGroupsContainer>
  );
};

export default memo(AdminPageGroups);
